import styled from 'styled-components';

const ResultCount = styled.div`
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.2px;
`;

export default ResultCount;
